module.exports = __webpack_public_path__ + "img/placeholder-card.401e98e.png";